import StuffAvailableIndex from '@/Libs/Pages/Panel/StuffAvailable/StuffAvailableIndex.vue'
import BranchSessionIndex from '@/Libs/Pages/Panel/BranchSession/BranchSessionIndex.vue'

export default [
    {
        name: 'stuff-available',
        path: '/stuff-available',
        component: StuffAvailableIndex,
        meta: {
            title: 'stuff_available.title.list',
            permission: 'stuff_available_list'
        },
    },
    {
        name: 'branch-session',
        path: '/branch-session',
        component: BranchSessionIndex,
        meta: {
            title: 'branch_session.title.list',
            permission: 'session_list'
        },
    },
];